<template lang="pug">
	article.page-container.is-flex
		markdown-article(:source="HomeMd")
		p
			| You can open the table of contents by clicking
			a.spaced-anchor(href="#" @click.prevent="onClick") here
			| or the icon in the {{ corner }} corner.

		.info-box
			| This website is still under construction!
		//-portal(to="hero")
			div Home hero
</template>

<script>
import MarkdownArticle from '@/components/MarkdownArticle'
import HomeMd from '@/markdown/Home.md'
import { EventBus } from '@/helpers/event-bus'

export default {
	name      : 'Home',
	components: { MarkdownArticle },
	metaInfo  : {
		title: 'Hukopedia'
	},
	data () {
		return {
			HomeMd,
			corner: ''
		}
	},
	mounted () {
		window.addEventListener('resize', this.onResize)
		this.onResize()
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.onResize)
	},
	methods: {
		onClick () {
			EventBus.$emit('menu-open')
		},
		onResize () {
			this.corner = window.screen.width >= 650 ? 'top-left' : 'top-right'
		}
	}
}
</script>
